exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dv-zahlungen-list .header-row{white-space:nowrap}dv-zahlungen-list:focus{outline:none}dv-zahlungen-list .beitraggrundrow{border:none;background-color:#dfdfdf;height:16px}dv-zahlungen-list .beitraggrundrow>td{height:16px!important;line-height:16px!important}dv-zahlungen-list .checkbox-alle{min-width:65px;margin-top:-11px}dv-zahlungen-list .checkbox-alle label input[type=checkbox]+span:before{margin-right:-49px}dv-zahlungen-list .checkbox-alle label input[type=checkbox]+span{padding:24px}dv-zahlungen-list .checkbox-alle label input[type=checkbox]:checked+span:after{left:28px;top:28px}dv-zahlungen-list .right{text-align:right}dv-zahlungen-list .checkbox-intable{margin-top:-2px;margin-right:-8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-zahlungen-list/dv-zahlungen-list.scss
// module id = QbT7
// module chunks = 0